import React from "react";

const classDaRates = [
  { city: "A Class", rate: "Rs. 700/-" },
  { city: "B Class", rate: "Rs. 600/-" },
  { city: "C Class", rate: "Rs. 500/-" },
];

const indicativeCosts = [
  { city: "A Class", cost: "Rs. 18.00 lacs" },
  { city: "B Class", cost: "Rs. 15.20 lacs" },
  { city: "C Class", cost: "Rs. 12.40 lacs" },
];

const MiniTable = ({ headers, rows }) => (
  <table className="mt-2 w-full border-collapse text-left text-[13px] leading-[1.55]">
    <thead>
      <tr className="border-b border-[#d9e2ea]">
        {headers.map((header) => (
          <th
            key={header}
            className="px-3 py-2 font-bold text-[#1f3556]"
            scope="col"
          >
            {header}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows.map((row) => (
        <tr className="border-b border-[#e5ebf0] last:border-0" key={row[0]}>
          {row.map((cell) => (
            <td className="px-3 py-2 align-top text-[#111827]" key={cell}>
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

const PromotionalSchemesContent = () => {
  return (
    <div className="space-y-7 text-[#333333]">
      <section className="space-y-3">
        <h2 className="text-lg font-bold text-[#183967]">
          Marketing Assistance Scheme
        </h2>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          The Marketing Assistance Scheme is meant for individual
          crafts-persons, beneficiaries of NMDFC as well as SHG members and is
          implemented through SCAs with a view to support the crafts-persons to
          promote marketing & sale of their products at remunerative prices.
          NMDFC assists the SCAs in organizing State/District level exhibitions
          at selected locations. In these exhibitions, handloom/handicraft
          products of Minority crafts-persons are exhibited and sold. Such
          exhibitions also serve the purpose of organizing "buyer seller meet",
          which is considered very useful for product development and market
          promotion, for domestic market as well as for exports. NMDFC provide
          grants for organizing exhibitions, as per the specific guidelines of
          the scheme, after due appraisal of the proposals.
        </p>
      </section>

      <div className="overflow-x-auto rounded-lg bg-white p-4 shadow-[0_8px_24px_rgba(15,35,58,0.08)]">
        <table className="min-w-[760px] w-full border-collapse text-left text-[13px] leading-[1.55] text-[#111827]">
          <thead>
            <tr className="bg-[#eaf2ff] text-[#1f3556]">
              <th className="w-[70px] px-4 py-3 font-bold" scope="col">
                S.No.
              </th>
              <th className="w-[150px] px-4 py-3 font-bold" scope="col">
                Parameters
              </th>
              <th className="px-4 py-3 font-bold" scope="col">
                Details
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-[#e5ebf0]">
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                01
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                Indicative Stall Rent
              </td>
              <td className="px-4 py-4 align-top">
                For A Class cities Rs. 22,000/stall, For B Class cities Rs.
                18,000/stall, For C Class cities Rs. 14,000/stall. All metros
                are A class cities, All State Capitals other than Metros are B
                Class cities, District headquarters/ other cities are C Class
                cities.
              </td>
            </tr>
            <tr className="border-b border-[#e5ebf0]">
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                02
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                DA (per day)
              </td>
              <td className="px-4 py-4 align-top">
                <MiniTable
                  headers={["Class of City", "DA Rate"]}
                  rows={classDaRates.map((item) => [item.city, item.rate])}
                />
              </td>
            </tr>
            <tr className="border-b border-[#e5ebf0]">
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                03
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                Total Cost for organising exhibition at SCA level
              </td>
              <td className="px-4 py-4 align-top">
                <MiniTable
                  headers={["Class of City", "Total Indicative Cost"]}
                  rows={indicativeCosts.map((item) => [item.city, item.cost])}
                />
                <p className="mt-2 text-justify">
                  The overall cost for organizing the exhibition would include
                  hiring of space for exhibition, erection of stalls- its
                  decoration & lighting, publicity & advertisement, branding,
                  TA, fixed DA, fire-fighting arrangements, insurance,
                  transportation of exhibits, expenses in organizing buyer
                  seller meet, etc.
                </p>
              </td>
            </tr>
            <tr className="border-b border-[#e5ebf0]">
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                04
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                Participants
              </td>
              <td className="px-4 py-4 align-top">
                60 local artisans/beneficiaries and 20 artisans/beneficiaries
                from outside the state. NMDFC will provide the list of 20
                artisans/beneficiaries either out of its own data bank or from
                the other States. This will help to provide variety to products
                brought in the exhibition. List of 20 artisans will be provided
                at least 10 days before start of exhibition by NMDFC, else
                organizing SCA will draw participants out of waiting list on
                hearing from NMDFC. This is to ensure that the stalls are not
                left vacant in the exhibition.
              </td>
            </tr>
            <tr className="border-b border-[#e5ebf0]">
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                05
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                Max. Stalls in Exhibition
              </td>
              <td className="px-4 py-4 align-top">
                40 stalls. If lesser number of stall are put, then the
                expenditure would be reduced proportionately.
              </td>
            </tr>
            <tr className="border-b border-[#e5ebf0]">
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                06
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                Duration of exhibition
              </td>
              <td className="px-4 py-4 align-top">
                15 Days. If exhibition is organized for lesser number of days,
                expenditure would be reduced proportionately.
              </td>
            </tr>
            <tr className="border-b border-[#e5ebf0]">
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                07
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                Means of Financing NMDFC : SCA
              </td>
              <td className="px-4 py-4 align-top">90% : 10%</td>
            </tr>
            <tr className="border-b border-[#e5ebf0]">
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                08
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                Occupancy in each Stall
              </td>
              <td className="px-4 py-4 align-top">
                Each Stall will be shared by two participants.
              </td>
            </tr>
            <tr className="border-b border-[#e5ebf0]">
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                09
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                Size of Each Stall
              </td>
              <td className="px-4 py-4 align-top">
                Should normally be of 10fts x 10fts size.
              </td>
            </tr>
            <tr className="border-b border-[#e5ebf0]">
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                10
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                Maintenance of Sales Figure
              </td>
              <td className="px-4 py-4 align-top">
                Participants have to maintain Bill Book and all sales should be
                recorded in it. The representative of the SCA should maintain a
                Sales Register in respect of all the participants.
              </td>
            </tr>
            <tr>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                11
              </td>
              <td className="px-4 py-4 align-top font-bold text-[#1f3556]">
                Maintenance of Attendance Record
              </td>
              <td className="px-4 py-4 align-top">
                The representative of the SCA should maintain attendance
                register & attendance of the artisan is to be taken daily to
                ensure their presence during the exhibition. Attendance of the
                artisans will also help to regulate payment of DA to the
                artisan.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-[#183967]">
          Grant in Aid Assistance scheme
        </h2>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          The SCAs of NMDFC are supported under the scheme of Grant In Aid
          Assistance (GIA) of the Ministry of Minority Affairs to strengthen
          their infrastructure for effective implementation of NMDFC schemes. So
          far, Rs.25.94 (upto 12.01.2021) crores has been released to the
          various SCAs by NMDFC.
        </p>
      </section>
    </div>
  );
};

export default PromotionalSchemesContent;
